import(/* webpackMode: "eager" */ "/vercel/path0/app/author/[id]/page.tsx");
